import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { excelExport, jobDowlod, semesterList, gradeList, classList, finalGrade, getOrgNameList as _getOrgNameList, getSpecialtyNameList as _getSpecialtyNameList } from "@/api/management/staff";
import importExcel from "@/components/dialog/import/importExcel.vue";
export default {
  name: "search",
  components: {
    importExcel: importExcel
  },
  props: [],
  data: function data() {
    return {
      semesterList: [],
      //学期列表
      gradeList: [],
      //年级列表
      classList: [],
      //班级列表
      orgNameList: [],
      //专业科列表
      specialtyNameList: [],
      //专业列表
      searchData: {
        semesterId: "",
        //学期id
        gradeId: "",
        //年级id
        classId: "",
        //班级id
        studentName: "",
        courseName: "",
        orgNo: "",
        specialtyId: "",
        //专业id
        teacherName: ""
      },
      loading: false,
      current: 1,
      size: 10,
      total: 0,
      tableData: [],
      uplodData: {
        state: false,
        type: ""
      }
    };
  },
  computed: {},
  created: function created() {
    var _this = this;

    this.getsemesterList().then(function () {
      _this.initPage();
    });
    this.getOrgNameList();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    downloadExcel: function downloadExcel() {
      var _this2 = this;

      this.$DownLoad(excelExport(this.searchData), null, function (res) {
        if (res.status == 200) {// this.$message.success("开始下载");
        } else {
          _this2.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this2.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    },
    initPage: function initPage() {
      this.current = 1;
      this.getList();
    },
    change: function change() {},
    // 获取专业科列表
    getOrgNameList: function () {
      var _getOrgNameList2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_getOrgNameLis, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _getOrgNameList();

              case 2:
                _yield$_getOrgNameLis = _context.sent;
                data = _yield$_getOrgNameLis.data;

                if (data.code == 0) {
                  this.orgNameList = data.data;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getOrgNameList() {
        return _getOrgNameList2.apply(this, arguments);
      }

      return getOrgNameList;
    }(),
    changeOrgNo: function changeOrgNo() {
      this.specialtyNameList = [];
      this.searchData.specialtyId = "";
      this.gradeList = [];
      this.searchData.gradeId = "";
      this.searchData.classId = "";
      this.classList = []; // 获取专业

      this.getSpecialtyNameList(); // this.initPage();
    },
    //获取专业列表
    getSpecialtyNameList: function () {
      var _getSpecialtyNameList2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_getSpecialtyN, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _getSpecialtyNameList(this.searchData.orgNo);

              case 2:
                _yield$_getSpecialtyN = _context2.sent;
                data = _yield$_getSpecialtyN.data;

                if (data.code == 0) {
                  this.specialtyNameList = data.data;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSpecialtyNameList() {
        return _getSpecialtyNameList2.apply(this, arguments);
      }

      return getSpecialtyNameList;
    }(),
    // 专业改变查年级(传专业id，专业科id) 年级，班级都清空
    changeSpecial: function changeSpecial() {
      this.gradeList = [];
      this.searchData.gradeId = "";
      this.searchData.classId = "";
      this.classList = [];
      this.getGradeList(); // this.initPage();
    },
    // 获取年级
    getGradeList: function () {
      var _getGradeList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$gradeList, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return gradeList({
                  specialtyId: this.searchData.specialtyId,
                  orgNo: this.searchData.orgNo
                });

              case 2:
                _yield$gradeList = _context3.sent;
                data = _yield$gradeList.data;

                if (data.code == 0) {
                  this.gradeList = data.data;
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getGradeList() {
        return _getGradeList.apply(this, arguments);
      }

      return getGradeList;
    }(),
    // 年级改变查班级
    changeGrade: function changeGrade() {
      this.getClassList();
      this.searchData.classId = "";
      this.classList = []; // this.initPage();
    },
    // 班级列表
    getClassList: function () {
      var _getClassList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$classList, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return classList({
                  gradeId: this.searchData.gradeId,
                  orgNo: this.searchData.orgNo,
                  specialtyId: this.searchData.specialtyId
                });

              case 2:
                _yield$classList = _context4.sent;
                data = _yield$classList.data;

                if (data.code == 0) {
                  this.classList = data.data;
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getClassList() {
        return _getClassList.apply(this, arguments);
      }

      return getClassList;
    }(),
    // 获取学期信息
    getsemesterList: function () {
      var _getsemesterList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$semesterList, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return semesterList();

              case 2:
                _yield$semesterList = _context5.sent;
                data = _yield$semesterList.data;

                if (data.code == 0) {
                  this.semesterList = data.data;
                  this.searchData.semesterId = this.semesterList[0].id;
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getsemesterList() {
        return _getsemesterList.apply(this, arguments);
      }

      return getsemesterList;
    }(),
    changePage: function changePage(page) {
      this.current = page;
      this.getList();
    },
    getList: function () {
      var _getList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var params, _yield$finalGrade, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.loading = true;
                params = _objectSpread(_objectSpread({}, this.searchData), {}, {
                  current: this.current,
                  size: this.size
                });
                _context6.next = 4;
                return finalGrade(params);

              case 4:
                _yield$finalGrade = _context6.sent;
                data = _yield$finalGrade.data;
                this.loading = false;

                if (data.code == 0) {
                  this.tableData = data.data.records;
                  this.total = data.data.total;
                } else {
                  this.$message.error(data.data.msg);
                }

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getList() {
        return _getList.apply(this, arguments);
      }

      return getList;
    }(),
    reset: function reset() {
      this.searchData = {
        semesterId: "",
        //学期id
        gradeId: "",
        //年级id
        classId: "",
        studentName: "",
        courseName: "",
        orgNo: "",
        specialtyId: "",
        //专业id
        teacherName: ""
      };
      this.searchData.semesterId = this.semesterList[0].id;
      this.initPage();
    },
    closeUplod: function closeUplod(val) {
      this.uplodData.state = val;
    },
    saveSuccess: function saveSuccess() {
      this.initPage();
    },
    importExcel: function importExcel() {
      this.uplodData.state = true;
    },
    // 模板下载
    downloadTemplate: function downloadTemplate() {
      this.downloadFn(jobDowlod());
    },
    downloadFn: function downloadFn(url) {
      var _this3 = this;

      this.$DownLoad(url, null, function (res) {
        if (res.status != 200) {
          _this3.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this3.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    }
  }
};